import * as z from "zod";
import { mutator } from "./mutator";

export const recordListControlChange = mutator({
  schema: z.object({
    page: z.string().max(32),
    control: z.string().max(32),
    value: z.string().max(64),
  }),
  resolve: {},
  permissions: {
    none: "records that the caller changed a control on their own screen",
  },
  description:
    "Triggered when a user sorts or filters a workflow or link list.",
  interactionType: "view",
  fn: async () => {},
});
